import { render, staticRenderFns } from "./ChangeShipmentAccountModule.vue?vue&type=template&id=e985d36c&scoped=true&"
import script from "./ChangeShipmentAccountModule.vue?vue&type=script&lang=js&"
export * from "./ChangeShipmentAccountModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e985d36c",
  null
  
)

export default component.exports